import React from "react";
import { X } from "lucide-react";

export default function InventoryNotesModal({
  isOpen,
  onClose,
  item,
  tempNotes,
  setTempNotes,
  onSubmit
}) {
  if (!isOpen || !item) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: "500px" }}>
        <div className="modal-header">
          <h3>Edit Item Notes</h3>
          <button className="modal-close-btn" onClick={onClose}>
            <X size={18} />
          </button>
        </div>
        <div style={{ padding: "1.5rem" }}>
          <div style={{ marginBottom: "1rem" }}>
            <span style={{ fontSize: "0.85rem", color: "var(--text-secondary)", display: "block" }}>Item</span>
            <strong style={{ color: "var(--primary)", fontSize: "1.05rem" }}>{item.sku}</strong>
            <span style={{ color: "var(--text-primary)", display: "block", marginTop: "0.25rem" }}>{item.name}</span>
          </div>
          
          <div style={{ marginBottom: "1.5rem" }}>
            <span style={{ fontSize: "0.85rem", color: "var(--text-secondary)", display: "block", marginBottom: "0.5rem" }}>Log History</span>
            <div 
              style={{ 
                display: "flex", 
                flexDirection: "column", 
                gap: "0.75rem", 
                maxHeight: "300px", 
                overflowY: "auto",
                paddingRight: "0.5rem",
                marginBottom: "1rem"
              }}
            >
              {/* Backward compatibility: display string notes if present */}
              {item.notes && (!item.logs || item.logs.length === 0) && (
                <div style={{ backgroundColor: "rgba(255, 255, 255, 0.05)", padding: "0.75rem", borderRadius: "6px" }}>
                  <span style={{ fontSize: "0.75rem", color: "var(--text-muted)", display: "block", marginBottom: "0.25rem" }}>Legacy Note</span>
                  <p style={{ margin: 0, fontSize: "0.9rem", color: "var(--text-primary)", whiteSpace: "pre-wrap" }}>{item.notes}</p>
                </div>
              )}
              
              {item.logs && [...item.logs].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)).map((log, idx) => (
                <div key={idx} style={{ backgroundColor: "rgba(255, 255, 255, 0.05)", padding: "0.75rem", borderRadius: "6px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.25rem" }}>
                    <span style={{ fontSize: "0.75rem", color: "var(--primary)", fontWeight: 600, textTransform: "uppercase" }}>{log.type}</span>
                    <span style={{ fontSize: "0.7rem", color: "var(--text-muted)" }}>{new Date(log.timestamp).toLocaleString()}{log.author ? ` • ${log.author}` : ""}</span>
                  </div>
                  <p style={{ margin: 0, fontSize: "0.9rem", color: "var(--text-primary)", whiteSpace: "pre-wrap" }}>{log.text}</p>
                </div>
              ))}

              {(!item.logs || item.logs.length === 0) && !item.notes && (
                <div style={{ color: "var(--text-muted)", fontSize: "0.85rem", fontStyle: "italic" }}>No logs recorded yet.</div>
              )}
            </div>
          </div>
          
          <div className="form-group" style={{ marginBottom: "1.5rem" }}>
            <label className="form-label" htmlFor="itemNotes">Append New Log</label>
            <textarea
              id="itemNotes"
              className="form-input"
              style={{ minHeight: "80px", padding: "0.75rem" }}
              value={tempNotes}
              onChange={(e) => setTempNotes(e.target.value)}
              placeholder="Add tracking updates, condition reports, or handling instructions..."
            />
          </div>
          
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.75rem" }}>
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
            <button type="button" className="btn btn-primary" onClick={onSubmit} disabled={!tempNotes.trim()}>
              Save Log
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
